import React, { SelectHTMLAttributes } from 'react';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  wrapperClassName?: string;
  options: { value: string | number; label: string }[];
  isLoading?: boolean; // <-- ADDED isLoading prop
}

const Select: React.FC<SelectProps> = ({
  label,
  name,
  error,
  options,
  wrapperClassName = "mb-4",
  isLoading = false, // <-- ADDED default value
  ...props
}) => {
  return (
    <div className={wrapperClassName}>
      {label && (
        <label htmlFor={name} className="block text-sm font-medium text-neutral-dark mb-1">
          {label}
        </label>
      )}
      <div className="relative"> {/* Added for potential spinner positioning */}
        <select
          id={name}
          name={name}
          className={`mt-1 block w-full pl-3 pr-10 py-2 text-base border ${
            error ? 'border-red-500' : 'border-neutral-DEFAULT'
          } focus:outline-none focus:ring-primary focus:border-primary sm:text-sm rounded-md ${
            isLoading ? 'opacity-70 bg-neutral-light cursor-not-allowed' : '' // Style for loading
          }`}
          disabled={isLoading || props.disabled} // Disable select when loading
          {...props}
        >
          {/* Optional: Show a "Loading..." option if isLoading and no other options yet, or just disable */}
          {isLoading && options.length <=1 && <option>Loading categories...</option>}
          {!isLoading && options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {/* You could add a spinner icon inside the select or next to it if desired */}
        {/* For example:
          {isLoading && (
            <div className="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none">
              <svg className="animate-spin h-5 w-5 text-neutral-dark" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </div>
          )}
        */}
      </div>
      {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
    </div>
  );
};

export default Select;